import { Component } from '@angular/core';

@Component({
    selector: 'r1-compass-lib-divider',
    imports: [],
    template: ` <div class="divider-dashed"></div> `,
    styles: `
        .divider-dashed {
            grid-area: divider;
            height: 1px;
            margin: 10px 0;
            border-bottom: dashed 1px var(--r1-smoke);
        }
    `,
})
export class DividerComponent {}
